import { LocaleValue } from "@eres/core/dist/LocaleValue";
import React, { Component } from "react";
import Strings, { LVStrings } from "@my-dld/assets/strings";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { OwnerCommitteeContext } from "@my-dld/contexts/OwnerCommitteeContext";
import { Redirect } from "react-router";
import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import OwnerCommitteeRegistration from "./OwnerCommitteeRegistration";
import { BaseTabuRequestProps } from "../TabuRequest/BaseTabuRequestForm";
import OwnerCommitteeSteps from "./OwnerCommitteeSteps";
import { OwnerCommitteeDocument } from "../../ownercommitteeapi/entities";
import PageContent from "@my-dld/components/PageContent";
import { extractPropInfo } from "../MyDLD/PropertyDetails";

type OwnerCommitteeComponent<P, S> = React.ComponentClass<P, S>

export enum TrackIndex {
	COMMITTEE_STEPS = 0,
	COMMITTEE_DOCUMENTS = 1,
}

interface IOwnerCommitteeTrack {
	index: number;
	name: LocaleValue;
	screen: OwnerCommitteeComponent<any, any>;
}

const OwnerCommitteeTrack: IOwnerCommitteeTrack[] = [
	{
		index: TrackIndex.COMMITTEE_STEPS,
		name: LVStrings.rt_procedure_details,
		screen: OwnerCommitteeSteps,
	},
	{
		index: TrackIndex.COMMITTEE_DOCUMENTS,
		name: LVStrings.rt_parties_information,
		screen: OwnerCommitteeRegistration,
	}
];

interface Props extends RoutedViewProps {

}

interface State {
	property: AssetCard;
	documents: OwnerCommitteeDocument[];
	isDewaRequire: Boolean;
	current: IOwnerCommitteeTrack;
	showPopup?: boolean;
	procedureNumber?: string;
}

export class OwnerCommittee extends Component<Props, State> {
	static contextType = OwnerCommitteeContext;
	context!: React.ContextType<typeof OwnerCommitteeContext>;

	constructor( props: Props ) {
		super( props );
		const property = props.location.state ? props.location.state.property : undefined;
		this.state = {
			current: OwnerCommitteeTrack[ 0 ],
			property: property,
			isDewaRequire: false,
			documents: []
		};
	}

	render() {
		const { current, property } = this.state;
		if ( property == undefined )
			return <Redirect to={ "/mydld" }/>;
		const { val, lbl } = extractPropInfo( property );
		return <React.Fragment>
			<PageContent
				title={ `${ Strings.owner_committee_reg } - ${ lbl } : ${ val }` }
				contentClass="col-md-12 property-details"
				hideQLinks={ true }>
				{ current && <this.state.current.screen
					holder={ this }
					property={ property }
					onPrevious={ this.onPrevious }
					setDocuments={ this.setDocuments }
					getDocuments={ this.getDocuments }
					onNext={ this.onNext }/> }
			</PageContent>
		</React.Fragment>;
	}

	private onPrevious = ( index: TrackIndex ) => {
		if ( index > 0 ) {
			this.setState( { current: OwnerCommitteeTrack[ index - 1 ] } );
		} else {
			this.setState( { current: OwnerCommitteeTrack[ 0 ] } );
		}
	};

	private onNext = ( index: TrackIndex ) => {
		if ( index === ( OwnerCommitteeTrack.length - 1 ) ) {
			this.setState( { current: OwnerCommitteeTrack[ index ] } );
		}
	};

	private setDocuments = ( documents: OwnerCommitteeDocument[], isRequired: boolean, callBack: () => void ) => {
		this.setState( { documents: documents, isDewaRequire: isRequired }, callBack );
	};

	private getDocuments = ( key: string ) => {
		switch ( key ) {
			case "isDewaRequired":
				return this.state.isDewaRequire;
			case "documents":
				return this.state.documents;
		}
	};
}

export interface OwnerCommitteeProps extends BaseTabuRequestProps {
	holder: any;
	property: AssetCard;
	onPrevious: ( index: TrackIndex ) => void;
	onNext: ( index: TrackIndex ) => void;
	setDocuments: ( documents: OwnerCommitteeDocument[], isRequired: boolean, callBack: () => void ) => void;
	getDocuments: ( key: string ) => any;
}
